export default __webpack_public_path__ + "static/media/Frame_2524-min.4d890c7b.jpg";